<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition" :max-width="max_width">
    <v-card>
      <!-- deze niet vervangen door default navbar, je kunt geen 2 v-app-bars hebben in 1 scherm. 
           Dat gaat mis. Toolbar (zoals hieronder kan weer wel)
           Dit kan overigens wel:
           <v-app-bar color="warning" dark app fixed> Main Header </v-app-bar>
           <v-app-bar color="primary" dark fixed class="mt-14"> component header </v-app-bar>               
      -->
      <v-toolbar :color="nav_color" dark class="text-h5">
        <v-app-bar-nav-icon><v-icon large>{{ `${this.caption_icon}` }}</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title>{{ this.caption }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <div :class="text_class" v-html="message" />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn text @click="close()">Close</v-btn>
      </v-card-actions>
    </v-card>
 </v-dialog>          
</template>

<script>
    export default {
      data() {
        return {
          dialog: false,
          nav_color: '',
          caption: '',
          message: '',
          caption_icon: '',
          max_width: 600,
          text_class: "text-center text-h6 pa-12",
        }
      }, 
      methods: {
        open(type, caption, message) {        
          switch(type){
            case 'warning':
              this.nav_color='warning'
              this.caption_icon='mdi-alert-outline' 
              break;
            case 'info':
              this.nav_color='success'
              this.caption_icon='mdi-check-circle-outline'
              break;
            case 'error':
              this.nav_color='error'
              this.caption_icon='mdi-close-circle-outline' 
              break;
            default:
              break;      
          }

          this.caption = caption;
          this.message = message;          
          this.dialog = true;

        },
        close() {
          this.caption = ''
          this.message = ''
          this.dialog = false;          
          this.$emit('standard_dialog_close')
        },
        setWidth(width) {
          this.max_width = width;
        },
        setTextClass(textclass) {
          this.text_class = textclass;
        }    
      }
    }
</script>
<style scoped>
</style>